import { EdcTerminalCreatePage } from "@/features/edc-terminal/pages/EdcTerminalCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/edc-terminal/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["edc_terminals.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: EdcTerminalCreatePage,
});
